export default __webpack_public_path__ + "static/professional-inteligence-v4-2991b62eabe2d8f7ba449d4ffeb2fc97.svg";